// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"61eacf3e","57":"b40ad882"}[chunkId] + ".chunk.css";
};